import React from 'react';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {Link} from "react-router-dom";

export default function DisabledTabs() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div id={"PageNavigation"}>
            <Paper square>
                <Tabs
                    value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}
                    aria-label="disabled tabs example"
                >
                    <Tab label="Available" component={Link} to={"/"}/>
                    <Tab label="Sold" component={Link} to={"/sold"}/>
                    <Tab label="Memory Lane" component={Link} to={"/memoryLane"} />
                </Tabs>
            </Paper>
        </div>
    );
}
